import { TableViewDialog, TableDialogFooter, TableDialogBtn } from "../style";
import Select from "react-select";

const ModuleBoardDialog = ({
  orderItem,
  tableManager,
  boardIdentifiers,
  updateModuleProperties,
  toggleClearOverrideModal,
  setClearOverrideFunc,
  clearModuleOverrides,
  mutateCurrentRoom,
  setCurrentTab,
}) => {
  return (
    <TableViewDialog onClick={(e) => e.stopPropagation()}>
      <div className="d-flex flex-column row-gap-3">
        {boardIdentifiers.map((identifier, index) => {
          const property = orderItem.property_list.find(
            (e) => e.identifier === identifier
          );

          return (
            <div key={identifier} onClick={(e) => e.stopPropagation()}>
              {property && (
                <>
                  <p className="grey_letter mb-1">{property.name}</p>
                  <div className="column-gap-3 d-flex align-items-center">
                    {property.is_editable ? (
                      <>
                        <Select
                          autoFocus={index === 0}
                          className="list-summary-select"
                          key={index}
                          isDisabled={!property.is_editable}
                          value={
                            property.options.find(
                              (option) =>
                                option.selected && property.is_overridden_v2
                            ) || null
                          }
                          onChange={(selectedOption) => {
                            if (selectedOption.identifier === "__add_more__") {
                              if (setCurrentTab) {
                                setCurrentTab("materials", "boards");
                              } else {
                                tableManager.clear();
                              }
                              return;
                            }
                            property.is_overridden_v2 = true;
                            property.options.forEach((o) => {
                              o.selected =
                                o.identifier === selectedOption.identifier;
                            });
                            mutateCurrentRoom();
                            updateModuleProperties({
                              id: orderItem.id,
                              propIdentifier: property.uniq_id,
                              optionIdentifier: selectedOption.identifier,
                            });
                          }}
                          options={[
                            ...property.options.map(
                              (option, optionIndex) => {
                                option.value = option.name;
                                option.label = option.name;
                                option.isDisabled =
                                  option.settings_disabled === true ||
                                  option.settings_disabled === "true";
                                option.key = index;
                                return {
                                  value: option.name,
                                  label: option.name,
                                  ...option,
                                };
                              }
                            ),
                            ...(boardIdentifiers.some((id) =>
                              orderItem.property_list.some(
                                (e) => e.identifier === id && e.is_editable
                              )
                            ) ? [                            {
                              value: "... add more boards",
                              label: "... add more boards",
                              identifier: "__add_more__",
                              key: `add-more-${index}`,
                            }] : [])
                          ]}
                        />
                        {property.is_overridden_v2 &&
                          property.is_clearable &&
                          property.is_editable && (
                            <i
                              className="fa-regular fa-trash-can fs-6 pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleClearOverrideModal();
                                setClearOverrideFunc(() => () => {
                                  property.value_name =
                                    property.project_value_name;
                                  property.is_overridden_v2 = false;
                                  clearModuleOverrides({
                                    id: orderItem.id,
                                    propIdentifier: property.uniq_id,
                                  });
                                });
                              }}
                            />
                          )}
                      </>
                    ) : (
                      property &&
                      property.is_overridden_v2 && (
                        <div className="mt-1 text-disabled">
                          {property.options.find((option) => option.selected)
                            ?.name || "No Value"}
                        </div>
                      )
                    )}
                  </div>
                </>
              )}

              {property && !property.is_overridden_v2 && (
                <p className="m-0 grey_letter mt-2">{`Using ${property.value_name}`}</p>
              )}
            </div>
          );
        })}
      </div>
      <TableDialogFooter>
        <TableDialogBtn
          onClick={(e) => {
            e.stopPropagation();
            tableManager.clear();
          }}
          className="mt-3"
        >
          Done
        </TableDialogBtn>
      </TableDialogFooter>
    </TableViewDialog>
  );
};

export default ModuleBoardDialog;
